import Icon from "../icon/Icon";

export default function ButtonToggle({
  buttonLabel,
  className = "",
  theme,
  isSelected = false,
  onClick,
}) {
  return (
    <button
      className={`button button--toggle theme-${theme} ${className} ${
        isSelected ? "isSelected" : ""
      }`}
      title={buttonLabel}
      onClick={onClick}
    >
      {buttonLabel && (
        <div className="button-text">
          <span>{buttonLabel}</span>
        </div>
      )}
      {/* <Icon icon={icon} size={size} button={true} /> */}
    </button>
  );
}
